import React from 'react';
import { connect } from 'react-redux';
import DepotGestionSelect from './DepotGestionSelect';
import { fetchDepotsGestion } from 'store/depotGestion/depotGestionActions';

import withLoader from 'components/Shared/withLoader';

const DepotGestionSelectWithLoader = withLoader(DepotGestionSelect);

class DepotGestionSelectContainer extends React.Component {
    async componentDidMount() {

        if (this.props.depotsGestion.length > 0) {

            if (this.props.valueIsCode) {
                let depot = this.props.depotsGestion.find(x => x.codeDepot === this.props.value);
                if (depot) {
                    this.props.onChange(null, depot.codeDepot, depot);
                }
            }
            else {

                let depot = this.props.depotsGestion[this.props.value];
                if (depot) {
                    this.props.onChange(null, depot.codeDepot, depot);
                }
            }
        }
        else {
            await this.props.fetchDepotsGestion();
        }

    }


    componentDidUpdate(prevProps) {

        if (prevProps.depotsGestion.length === 0 && this.props.depotsGestion.length > 0) {


            if (this.props.valueIsCode) {
                let depot = this.props.depotsGestion.find(x => x.codeDepot === this.props.value);
                if (depot) {
                    this.props.onChange(null, depot.codeDepot, depot);
                }
            }
            else {

                let depot = this.props.depotsGestion[this.props.value];
                if (depot) {
                    this.props.onChange(null, depot.codeDepot, depot);
                }
            }

        }
    }


    render() {
        const { isLoading } = this.props;

        return (
            <DepotGestionSelectWithLoader
                isLoading={isLoading}
                {...this.props}
            />
        );
    }
}

const mapStateToProps = (state, ownProps) => {

    let depotsGestion = state.depotGestion.depotsGestion.items;

    if (ownProps.modeTri === 1) {
        depotsGestion = depotsGestion.sort((a, b) => a.nom > b.nom);
    }

    return {
        depotsGestion: depotsGestion,
        isLoading: state.depotGestion.depotsGestion.isLoading
    };
};


const mapDispatchToProps = dispatch => ({
    fetchDepotsGestion: () => dispatch(fetchDepotsGestion())
});


export default connect(mapStateToProps, mapDispatchToProps)(DepotGestionSelectContainer);